import { Button, Stack } from '@mantine/core';
import { QuestionGroup } from './QuestionGroup';
import { BuilderQuestionGroup } from '@/types/interview.types';

interface QuestionGroupListProps {
  groups: BuilderQuestionGroup[];
  onChange: (groups: BuilderQuestionGroup[]) => void;
}

export function QuestionGroupList({ groups, onChange }: QuestionGroupListProps) {
  const handleAddGroup = () => {
    const newGroup: BuilderQuestionGroup = {
      id: crypto.randomUUID(),
      name: `Question Group ${groups.length + 1}`,
      questions: [],
    };
    onChange([...groups, newGroup]);
  };

  const handleGroupChange = (index: number, updatedGroup: BuilderQuestionGroup) => {
    const newGroups = [...groups];
    newGroups[index] = updatedGroup;
    onChange(newGroups);
  };

  const handleRemoveGroup = (index: number) => {
    if (groups.length <= 1) {
      return; // Keep at least one group
    }
    const newGroups = groups.filter((_, i) => i !== index);
    onChange(newGroups);
  };

  return (
    <Stack gap="md">
      {groups.map((group, index) => (
        <QuestionGroup
          key={group.id}
          group={group}
          onChange={(updated) => handleGroupChange(index, updated)}
          onRemove={() => handleRemoveGroup(index)}
          canRemove={groups.length > 1}
        />
      ))}

      <Button
        variant="outline"
        size="sm"
        onClick={handleAddGroup}
        className="add-group-btn"
      >
        + Add another group
      </Button>
    </Stack>
  );
}
